module.exports = __webpack_public_path__ + "img/Slice1-min.2037ba6a.png";